import {
  BlogActionsWrapper,
  BlogCardBottomContentWrapper,
  BlogCardFollowProvider,
  BlogCardObjsContent,
  BlogCardOptionsProvider,
  BlogCardWebCoachProfileImg,
  BlogCardWebCoachWrapper,
  BlogCardWebContentWrapper,
  BlogCardWebDescription,
  BlogCardWebImage,
  BlogCardWebLink,
  BlogCardWebObjsWrapper,
  BlogCardWebProvider,
  BlogCardWebTitle,
  BlogCardWebWrapper,
  BlogOptions,
} from "../blogCard";
import { Listing } from "../../../interfaces/training-plan/Listing";
import { BlogCardUsername } from "../blogCard/BlogCardUsername";
import { BlogCardBottomDate } from "../blogCard/BlogCardBottomDate";
import { BlogCardWebSave } from "../blogCard/blogCardWeb/BlogCardWebSave";

type BlogPageWebCardProps = {
  blog: Listing;
};

export const BlogPageWebCard = ({ blog }: BlogPageWebCardProps) => {
  return (
    <BlogCardWebProvider blog={blog}>
      <BlogCardFollowProvider coach={blog.user}>
        <BlogCardWebLink>
          <BlogCardWebWrapper>
            <BlogCardWebContentWrapper>
              <BlogCardWebTitle />
              <BlogCardWebDescription />
              <BlogCardWebObjsWrapper>
                <BlogCardObjsContent />
              </BlogCardWebObjsWrapper>

              <BlogCardWebCoachWrapper>
                <BlogCardWebCoachProfileImg />
                <BlogCardBottomContentWrapper>
                  <BlogCardUsername>{blog.user.name}</BlogCardUsername>
                  <BlogCardBottomDate date={blog.created_at} />
                </BlogCardBottomContentWrapper>

                <BlogActionsWrapper>
                  <BlogCardWebSave />
                  <BlogCardOptionsProvider>
                    <BlogOptions coach={blog.user} />
                  </BlogCardOptionsProvider>
                </BlogActionsWrapper>
              </BlogCardWebCoachWrapper>
            </BlogCardWebContentWrapper>

            <BlogCardWebImage />
          </BlogCardWebWrapper>
        </BlogCardWebLink>
      </BlogCardFollowProvider>
    </BlogCardWebProvider>
  );
};
